import { render, staticRenderFns } from "./LczyFooter.vue?vue&type=template&id=7216e510&scoped=true"
import script from "./LczyFooter.vue?vue&type=script&lang=js"
export * from "./LczyFooter.vue?vue&type=script&lang=js"
import style0 from "./LczyFooter.vue?vue&type=style&index=0&id=7216e510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7216e510",
  null
  
)

export default component.exports